import { memo, useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Radio from "@mui/material/Radio";
import {
  AutocompleteInput,
  maxLength,
  minLength,
  number,
  ReferenceInput,
  required,
  useSimpleFormIteratorItem,
} from "react-admin";
import { toCurrency } from "../../../../utils/formatter";
import InputAdornment from "@mui/material/InputAdornment";
import {
  filterToQuery,
  inputText,
  matchSuggestion,
  OptionRenderer,
} from "../../common/CustomSelectOption";
import JournalAmount from "../../../customerDebtPayments/common/JournalAmount";
import parserFormatNumInput from "../../../../utils/parserFormatNumInput";
import { useFormContext } from "react-hook-form";

const equalWithTotal = (value, allValues, elm) => {
  let totalCount = { debit: 0, credit: 0 };
  let journalType;
  const splite = elm.source.split(".");
  for (let i = 0; i < allValues.factory_debt_correction_journals.length; i++) {
    const elmt = allValues.factory_debt_correction_journals[i];
    if (!isNaN(parseFloat(elmt.debit))) {
      totalCount.debit += +elmt.debit;
    }
    if (!isNaN(parseFloat(elmt.credit))) {
      totalCount.credit += +elmt.credit;
    }

    if (!journalType) {
      if (+splite[1] === i) {
        // jika sama indexnya berarti inilah komponen yg mau di validasi
        if (+elmt.debit !== 0) {
          journalType = "debit";
        } else if (+elmt.credit !== 0) {
          journalType = "credit";
        } else {
          // mengikuti default nya atau nilai awal sebelom ada inputan apapun
          journalType = "debit";
        }
        // skipProcessLast = +elmt.debit + +elmt.credit;
      }
    }
  }

  if (totalCount[journalType] !== +allValues.total) {
    return (
      "All " +
      journalType +
      " must be equal with " +
      toCurrency(false).format(allValues.total) +
      " (total correction)"
    );
  }
  return undefined;
};

const validateCode = [required(), minLength(36), maxLength(36)];
const validateAmount = [required(), number(), equalWithTotal];

const JournalInputs = ({ idSource, debitSource, creditSource, debit, credit }) => {
  const { index } = useSimpleFormIteratorItem();
  const [radioChecked, setRadioChecked] = useState(
    index === 0 ? (debit && debit !== 0 ? "radio-debit" : "radio-credit") : ""
  );
  const { setValue, getValues } = useFormContext();

  useEffect(() => {
    if (index === 0) {
      if (debit && debit !== 0) {
        setRadioChecked("radio-debit");
      } else if (credit && credit !== 0) {
        setRadioChecked("radio-credit");
      }
    }
  }, [debit, credit, index]);

  const handleRadioDebitChange = () => {
    if (index === 0) {
      setRadioChecked("radio-debit");
      setValue(debitSource, getValues("total"));
    }
  };

  const handleRadioCreditChange = () => {
    if (index === 0) {
      setRadioChecked("radio-credit");
      setValue(creditSource, getValues("total"));
    }
  };

  return (
    <Grid
      container
      spacing={2}
      sx={{
        // "& .MuiGrid-item:not(:first-of-type)": { pt: 0 },
        "& .MuiGrid-item": { py: 1 },
        mt: 0,
      }}
    >
      <Grid item xs={6}>
        <ReferenceInput
          source={idSource}
          reference="coa"
          perPage={10}
          sort={{ field: "code", order: "ASC" }}
        >
          <AutocompleteInput
            label="mine.label.account"
            variant="outlined"
            fullWidth
            validate={validateCode}
            optionValue="id"
            // optionText="code"
            optionText={<OptionRenderer />}
            inputText={inputText}
            matchSuggestion={matchSuggestion}
            filterToQuery={filterToQuery}
            disabled={index === 0}
            helperText={false}
          />
        </ReferenceInput>
      </Grid>
      <Grid item xs={3}>
        <JournalAmount
          helperText={false}
          label="mine.label.debit"
          variant="outlined"
          source={debitSource}
          validate={validateAmount}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">Rp</InputAdornment>
            ),
            endAdornment:
              index === 0 ? (
                <Radio
                  id="radio-debit"
                  size="small"
                  checked={radioChecked === "radio-debit"}
                  onChange={handleRadioDebitChange}
                  value="a"
                  name="radiox"
                />
              ) : null,
          }}
          {...parserFormatNumInput}
          dependOn={
            index === 0
              ? [
                  "total",
                  radioChecked === "radio-debit" ? idSource : "",
                  creditSource,
                ]
              : ["total", "", creditSource]
          }
        />
      </Grid>
      <Grid item xs={3}>
        <JournalAmount
          helperText={false}
          label="mine.label.credit"
          variant="outlined"
          source={creditSource}
          validate={validateAmount}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">Rp</InputAdornment>
            ),
            endAdornment:
              index === 0 ? (
                <Radio
                  id="radio-credit"
                  size="small"
                  checked={radioChecked === "radio-credit"}
                  onChange={handleRadioCreditChange}
                  value="b"
                  name="radiox"
                />
              ) : null,
          }}
          {...parserFormatNumInput}
          dependOn={
            index === 0
              ? [
                  "total",
                  radioChecked === "radio-credit" ? idSource : "",
                  debitSource,
                ]
              : ["total", "", debitSource]
          }
        />
      </Grid>
    </Grid>
  );
};

const propsAreEqual = (prevProps, nextProps) => {
  if (
    prevProps.debit === nextProps.debit &&
    prevProps.credit === nextProps.credit &&
    prevProps.code === nextProps.code
  ) {
    // tidak perlu render ulang
    return true;
  }
  // perlu dirender ulang
  return false;
};
const Beruk = memo(JournalInputs, propsAreEqual);

const Inputs = ({
  formData, // The whole form data
  scopedFormData, // The data for this item of the ArrayInput
  getSource, // A function to get the valid source inside an ArrayInput
  ...rest
}) => {
  return (
    <Beruk
      {...scopedFormData}
      idSource={getSource("chart_of_account_id")}
      debitSource={getSource("debit")}
      creditSource={getSource("credit")}
    />
  );
};
export default Inputs;
